module.exports = __webpack_public_path__ + "img/f.5d38c4a1.jpg";